import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { PageHeaderComponent } from '../core/labels/page-header.component';
import { ToastComponent } from '../core/labels/toast.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { PanelComponent } from '../core/panels/panel.component';
import { HomeCardComponent } from '../home/home-card.component';

@Component({
  selector: 'app-preferences',
  imports: [
    RouterModule,
    ButtonComponent,
    HomeCardComponent,
    PageHeaderComponent,
    PanelComponent,
    ActionRowComponent,
    ToastComponent,
  ],
  template: `
    <app-page-header label="Preferences" headerSize="h1" />
    <div class="tw-grow tw-w-full tw-justify-center">
      <app-home-card type="Large">
        <div class="tw-pb-8 tw-w-full tw-min-w-0">
          <div
            class="tw-flex tw-justify-center"
            [class.tw-hidden]="!passwordChangeSuccess"
            [attr.aria-hidden]="!passwordChangeSuccess ? 'true' : null"
          >
            <app-toast
              type="Success"
              [dismissSeconds]="10"
              [dismiss]="true"
              (dismissed)="passwordChangeSuccess = false"
            >
              Password has been successfully changed.</app-toast
            >
          </div>
          <app-panel>
            <div class="tw-flex tw-items-center tw-p-4 tw-min-w-0">
              <div class="tw-flex tw-gap-2">
                <app-action-row class="tw-w-full">
                  <app-button
                    left1
                    label="Manage Communication Preferences"
                    routerLink="/communication-preferences"
                  />
                </app-action-row>
              </div>
            </div>
            @if (!session.user?.isSsoUser) {
              <div class="tw-flex tw-items-center tw-p-4 tw-min-w-0">
                <div class="tw-flex tw-gap-2">
                  <app-action-row class="tw-w-full">
                    <app-button
                      left1
                      label="Change password"
                      routerLink="/password-change"
                    />
                  </app-action-row>
                </div>
              </div>
            }
          </app-panel>
        </div>
      </app-home-card>
    </div>
  `,
  styles: ``,
})
export class PreferencesComponent extends BaseComponent {
  private route = inject(ActivatedRoute);

  passwordChangeSuccess = false;

  constructor() {
    super();
    this.route.queryParams.subscribe((params) => {
      if (params['passwordChanged']) {
        this.passwordChangeSuccess = true;
      }
    });
  }
}
